import { useT } from "../lib/i18n";

export function PrivacySection() {
  const t = useT();
  const copy = t.privacy;

  return (
    <section
      id="privacy"
      className="border-t border-margin dark:border-paper/10"
    >
      <div className="mx-auto max-w-4xl px-6 py-24">
        <p className="text-xs font-medium uppercase tracking-wider text-ink/50 dark:text-paper/50">
          {copy.label}
        </p>
        <h2 className="mt-2 font-display text-3xl sm:text-4xl font-semibold tracking-tight text-ink dark:text-paper max-w-2xl">
          {copy.heading}
        </h2>

        <ul className="mt-12 grid gap-3 sm:grid-cols-2">
          {copy.bullets.map((b) => (
            <li
              key={b}
              className="flex items-start gap-3 rounded-xl border border-margin dark:border-paper/10 p-4"
            >
              <span className="mt-0.5 h-4 w-4 flex-shrink-0 text-graphite dark:text-graphite-muted">
                <svg
                  viewBox="0 0 16 16"
                  fill="none"
                  stroke="currentColor"
                  strokeWidth="1.75"
                  strokeLinecap="round"
                  strokeLinejoin="round"
                >
                  <polyline points="3,8 7,12 13,4" />
                </svg>
              </span>
              <span className="text-sm text-ink/80 dark:text-paper/80 leading-relaxed">
                {b}
              </span>
            </li>
          ))}
        </ul>
      </div>
    </section>
  );
}
